module.exports = __webpack_public_path__ + "static/img/chery_2@2x.67f41ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/chery_2@2x.png
// module id = SBy2
// module chunks = 0